import type { Stat } from '../types/content'

export const stats: Stat[] = [
  { id: 'families', value: '500+', label: { en: 'Families Served', es: 'Familias Atendidas' } },
  { id: 'years', value: '10+', label: { en: 'Years of Experience', es: 'Años de Experiencia' } },
  { id: 'availability', value: '24/7', label: { en: 'Care Available', es: 'Cuidado Disponible' } },
  { id: 'satisfaction', value: '100%', label: { en: 'Client Satisfaction', es: 'Satisfacción del Cliente' } },
  { id: 'rating', value: '5.0', label: { en: 'Star Rating', es: 'Calificación en Estrellas' } },
]
